/* tslint:disable */
import {
  OtherOrderItem,
  OtherPayment
} from '../index';

declare var Object: any;
export interface OtherOrderInterface {
  "id"?: string;
  "orderId": string;
  "reference": string;
  "status": number;
  "paymentMethod": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "subTotal": number;
  "totalDiscount"?: number;
  "totalVolumeDiscount"?: number;
  "totalAmount": number;
  "totalPayment": number;
  "totalTax": number;
  "totalVat"?: number;
  "totalNetOfVat"?: number;
  "dateSettled"?: Date;
  "ORNumber"?: string;
  "ORDate"?: Date;
  "customerGender"?: string;
  "customerStreet1"?: string;
  "customerStreet2"?: string;
  "customerPhone"?: string;
  "customerFirstName": string;
  "customerLastName"?: string;
  "customerMiddleName"?: string;
  "customerExtension"?: string;
  "customerCity"?: string;
  "customerProvince"?: string;
  "customerPostalCode"?: string;
  "customerCountry"?: string;
  "customerEmail"?: string;
  "ticketNumber"?: string;
  "agentUsername"?: string;
  "failedEmailOR"?: boolean;
  "failedGenerateOR"?: boolean;
  "failedAgentUsername"?: boolean;
  "isUsernameIneligible"?: boolean;
  "failedShopStatusUpdate"?: boolean;
  "reprocessingCounter"?: number;
  orderItems?: OtherOrderItem[];
  payments?: OtherPayment[];
}

export class OtherOrder implements OtherOrderInterface {
  "id": string;
  "orderId": string;
  "reference": string;
  "status": number;
  "paymentMethod": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "subTotal": number;
  "totalDiscount": number;
  "totalVolumeDiscount": number;
  "totalAmount": number;
  "totalPayment": number;
  "totalTax": number;
  "totalVat": number;
  "totalNetOfVat": number;
  "dateSettled": Date;
  "ORNumber": string;
  "ORDate": Date;
  "customerGender": string;
  "customerStreet1": string;
  "customerStreet2": string;
  "customerPhone": string;
  "customerFirstName": string;
  "customerLastName": string;
  "customerMiddleName": string;
  "customerExtension": string;
  "customerCity": string;
  "customerProvince": string;
  "customerPostalCode": string;
  "customerCountry": string;
  "customerEmail": string;
  "ticketNumber": string;
  "agentUsername": string;
  "failedEmailOR": boolean;
  "failedGenerateOR": boolean;
  "failedAgentUsername": boolean;
  "isUsernameIneligible": boolean;
  "failedShopStatusUpdate": boolean;
  "reprocessingCounter": number;
  orderItems: OtherOrderItem[];
  payments: OtherPayment[];
  constructor(data?: OtherOrderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `OtherOrder`.
   */
  public static getModelName() {
    return "OtherOrder";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of OtherOrder for dynamic purposes.
  **/
  public static factory(data: OtherOrderInterface): OtherOrder{
    return new OtherOrder(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'OtherOrder',
      plural: 'OtherOrders',
      path: 'OtherOrders',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "orderId": {
          name: 'orderId',
          type: 'string'
        },
        "reference": {
          name: 'reference',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "paymentMethod": {
          name: 'paymentMethod',
          type: 'number',
          default: 0
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
        "lastUpdated": {
          name: 'lastUpdated',
          type: 'Date'
        },
        "subTotal": {
          name: 'subTotal',
          type: 'number',
          default: 0
        },
        "totalDiscount": {
          name: 'totalDiscount',
          type: 'number',
          default: 0
        },
        "totalVolumeDiscount": {
          name: 'totalVolumeDiscount',
          type: 'number',
          default: 0
        },
        "totalAmount": {
          name: 'totalAmount',
          type: 'number',
          default: 0
        },
        "totalPayment": {
          name: 'totalPayment',
          type: 'number',
          default: 0
        },
        "totalTax": {
          name: 'totalTax',
          type: 'number',
          default: 0
        },
        "totalVat": {
          name: 'totalVat',
          type: 'number',
          default: 0
        },
        "totalNetOfVat": {
          name: 'totalNetOfVat',
          type: 'number',
          default: 0
        },
        "dateSettled": {
          name: 'dateSettled',
          type: 'Date'
        },
        "ORNumber": {
          name: 'ORNumber',
          type: 'string'
        },
        "ORDate": {
          name: 'ORDate',
          type: 'Date'
        },
        "customerGender": {
          name: 'customerGender',
          type: 'string'
        },
        "customerStreet1": {
          name: 'customerStreet1',
          type: 'string'
        },
        "customerStreet2": {
          name: 'customerStreet2',
          type: 'string'
        },
        "customerPhone": {
          name: 'customerPhone',
          type: 'string'
        },
        "customerFirstName": {
          name: 'customerFirstName',
          type: 'string'
        },
        "customerLastName": {
          name: 'customerLastName',
          type: 'string'
        },
        "customerMiddleName": {
          name: 'customerMiddleName',
          type: 'string'
        },
        "customerExtension": {
          name: 'customerExtension',
          type: 'string'
        },
        "customerCity": {
          name: 'customerCity',
          type: 'string'
        },
        "customerProvince": {
          name: 'customerProvince',
          type: 'string'
        },
        "customerPostalCode": {
          name: 'customerPostalCode',
          type: 'string'
        },
        "customerCountry": {
          name: 'customerCountry',
          type: 'string'
        },
        "customerEmail": {
          name: 'customerEmail',
          type: 'string'
        },
        "ticketNumber": {
          name: 'ticketNumber',
          type: 'string'
        },
        "agentUsername": {
          name: 'agentUsername',
          type: 'string'
        },
        "failedEmailOR": {
          name: 'failedEmailOR',
          type: 'boolean',
          default: false
        },
        "failedGenerateOR": {
          name: 'failedGenerateOR',
          type: 'boolean',
          default: false
        },
        "failedAgentUsername": {
          name: 'failedAgentUsername',
          type: 'boolean',
          default: false
        },
        "isUsernameIneligible": {
          name: 'isUsernameIneligible',
          type: 'boolean',
          default: false
        },
        "failedShopStatusUpdate": {
          name: 'failedShopStatusUpdate',
          type: 'boolean',
          default: false
        },
        "reprocessingCounter": {
          name: 'reprocessingCounter',
          type: 'number',
          default: 0
        },
      },
      relations: {
        orderItems: {
          name: 'orderItems',
          type: 'OtherOrderItem[]',
          model: 'OtherOrderItem',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'orderId'
        },
        payments: {
          name: 'payments',
          type: 'OtherPayment[]',
          model: 'OtherPayment',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'orderId'
        },
      }
    }
  }
}
